import { render, staticRenderFns } from "./sandbox-auto-renewals.vue?vue&type=template&id=45c509c0&scoped=true&"
import script from "./sandbox-auto-renewals.vue?vue&type=script&lang=tsx&"
export * from "./sandbox-auto-renewals.vue?vue&type=script&lang=tsx&"
import style0 from "./sandbox-auto-renewals.vue?vue&type=style&index=0&id=45c509c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c509c0",
  null
  
)

export default component.exports